import { FC } from 'react';
import s from './collectionCard.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import parse from 'html-react-parser';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
import { CdnPath } from '@specs/cdn';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
type CollectionCardProps = {
  name: string;
  description: string;
  imageId: string;
  id: number;
};
export const CollectionCard: FC<CollectionCardProps> = ({
  id,
  name,
  description,
  imageId
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  return <div className={s.collectionCard} data-sentry-component="CollectionCard" data-sentry-source-file="CollectionCard.tsx">
            <div className={s.collectionCard__info}>
                <h5 className={s.collectionCard__title}>{name}</h5>
                <p className={s.collectionCard__description}>{parse(description)}</p>

                <Button id='explore_collection_button' onClick={async () => {
        await router.push({
          pathname: LinksEnum.EXPLORE_COLLECTION,
          query: {
            slug: id
          }
        });
      }} color='Black' size='large' data-sentry-element="Button" data-sentry-source-file="CollectionCard.tsx">
                    {tr({
          id: 'btn.explore'
        })}
                </Button>
            </div>
            <OptimizedImage boxClassName={s.collectionCard__image} path={CdnPath.collectionMeta} cdnId={imageId ?? ''} alt={name} title={name} style={{
      aspectRatio: '5/2'
    }} data-sentry-element="OptimizedImage" data-sentry-source-file="CollectionCard.tsx" />
        </div>;
};